import React from 'react';
import { getTranslatedText, useIntl } from '@nile/components';
import { Modal } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';

const DuplicateWarningModal = (props) => {
  const { modalActive, setModalActive, totalTickets, onDuplicateAll } = props;

  const intl = useIntl();

  return (
    <>
      <Modal
        open={modalActive}
        onClose={() => setModalActive(!modalActive)}
        variant="confirmation"
        title={<FormattedMessage id="app.general.toast.warning" />}
        primaryAction={{
          content: getTranslatedText(
            intl,
            'ticket.bulkClose.warning.duplicate'
          ),
          onAction: onDuplicateAll
        }}
        secondaryActions={[
          {
            content: getTranslatedText(
              intl,
              'ticket.bulkClose.warning.manuallyEdit'
            ),
            onAction: setModalActive
          }
        ]}
      >
        <div className="mt-10">
          <FormattedMessage
            id="tickets.bulkClosure.duplicate.warning.description"
            values={{ ticketCount: totalTickets }}
          />
        </div>
      </Modal>
    </>
  );
};

export default DuplicateWarningModal;
